import { FC } from "react";
import { Button, DialogActions, DialogContent, Typography } from "@mui/material";
import useModal from "../hooks/useModal";

type Props = {
	message: string;
	confirmLabel?: string;
	cancelLabel?: string;
};

const ConfirmDialog: FC<Props> = ({ message, confirmLabel, cancelLabel }) => {
	const { hide: hideModal } = useModal();

	return (
		<>
			<DialogContent>
				<Typography variant="body1">{message}</Typography>
			</DialogContent>
			<DialogActions>
				<Button variant="text" onClick={() => hideModal(false)}>
					{cancelLabel || 'Cancel'}
				</Button>
				<Button variant="contained" color="primary" onClick={() => hideModal(true)}>
					{confirmLabel || 'Confirm'}
				</Button>
			</DialogActions>
		</>
	);
};

export default ConfirmDialog;
